import React from "react";
import { Input } from "@/Components/Common/Tailwind";

export const Filter: React.FC<{ column: any }> = ({ column }) => {
  return <div style={{ marginTop: 5 }}>{column?.canFilter && column.render("Filter")}</div>;
};

export const DefaultColumnFilter: React.FC<{
  column: {
    filterValue: any;
    setFilter: (value: any) => void;
    preFilteredRows: { length: number };
  };
}> = ({
  column: {
    filterValue,
    setFilter,
    preFilteredRows: { length },
  },
}) => {
    return (
      <Input
        value={filterValue || ""}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setFilter(e.target.value || undefined);
        }}
        placeholder={`search (${length}) ...`}
      />
    );
  };

export const SelectColumnFilter: React.FC<{
  column: { filterValue: any; setFilter: (value: any) => void; preFilteredRows: any[]; id: string };
}> = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
  const options = React.useMemo(() => {
    const optionSet = new Set<any>();
    preFilteredRows.forEach((row) => {
      optionSet.add(row?.values?.[id]);
    });
    return [...optionSet.values()];
  }, [id, preFilteredRows]);

  return (
    <select
      id="custom-select"
      className="form-select"
      value={filterValue}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value="">All</option>
      {options.map((option) => (
        <option key={String(option)} value={option}>
          {String(option)}
        </option>
      ))}
    </select>
  );
};
